// extracted by mini-css-extract-plugin
module.exports = {"storyblok-rich-text":"StoryblokRichText_storyblok-rich-text__CV269"};